import React, { useCallback, useEffect, useState } from "react";

import { JGAPCommonTree } from "@app/components/treeListCommon";
import {
  selectCurrentProfTreeList,
  selectProfileTreeList,
  setProfTreeList,
  useAppDispatch,
  useAppSelector,
} from "@app/state";

import { ProfileListIco, ProfileListTitle } from "./item";
import "./profiletree.scss";

export const ProfileTreeList = () => {
  const [nodeId, setNodeId] = useState<string[]>([]);
  const theStateNode = useAppSelector(selectCurrentProfTreeList);
  const dispatch = useAppDispatch();

  const cellRender = useCallback(
    (e: any) => (
      <div>
        <ProfileListIco e={e} />
        <ProfileListTitle e={e} />
      </div>
    ),
    []
  );

  const ptlSelectionChanged = useCallback((e: any) => {
    dispatch(setProfTreeList(e.selectedRowsData[0]));
  }, []);

  useEffect(() => {
    if (theStateNode?.id && theStateNode.id !== nodeId[0]) {
      setNodeId([theStateNode.id]);
    }
  }, [theStateNode?.id || ""]);

  return (
    <JGAPCommonTree
      treeId={"profileTreeList"}
      treeDataSelector={selectProfileTreeList}
      currenNodeSelector={selectCurrentProfTreeList}
      cellRender={cellRender}
      treeSelectionChanged={ptlSelectionChanged}
    />
  );
};
